// components.
import { RowsRemo } from "./components/RowsRemo";

export const TableRemo = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 166px)",
        overflowY: "auto",
      }}
    >
      <RowsRemo />
    </div>
  );
};
